import { LIGHT_MODE_COLORS, DARK_MODE_COLORS } from "./colors.ts";

export const lightTheme = {
  colors: { ...LIGHT_MODE_COLORS },
};

export const darkTheme = {
  colors: { ...DARK_MODE_COLORS },
};

export type ThemeType = typeof lightTheme;
